module.exports = __webpack_public_path__ + "img/example5.57cb64d3.png";